<template>
  <router-link
    :to="link"
    class="cursor-pointer group rounded-md px-3 py-2 flex items-center text-sm font-medium"
    :class="linkClasses"
  >
    <!-- Heroicon name: user-circle -->
    <div class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" :class="iconClasses">
      <slot name="icon"></slot>
    </div>

    <span class="truncate">
      {{ name }}
    </span>
  </router-link>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "DetailsLink",
  props: {
    name: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    routeNameList: {
      type: Array
    },
    routePage: {
      type: String
    }
  },
  setup(props) {
    const route = useRoute();
    // Create status for css classes
    // Links if active, if matches route name or route page
    const linkStatus = computed(() => {
      if (props.routePage != undefined) {
        if (route.meta.page == props.routePage) {
          return "active";
        } else {
          return "inactive";
        }
      } else if (props.routeNameList != undefined) {
        if (props.routeNameList.includes(route.name)) {
          return "active";
        } else {
          return "inactive";
        }
      }
    });

    // CSS classes for icon
    const iconClasses = computed(() => {
      return {
        active: "text-blue-500 group-hover:text-blue-500",
        inactive: "text-gray-400 group-hover:text-gray-500"
      }[linkStatus.value as "active" | "inactive"];
    });
    // CSS classes for text
    const linkClasses = computed(() => {
      return {
        active: "bg-gray-50 text-blue-500 hover:bg-white",
        inactive: "text-gray-900 hover:text-gray-900 hover:bg-gray-100"
      }[linkStatus.value as "active" | "inactive"];
    });
    return { iconClasses, linkClasses };
  }
});
</script>
